import styled from 'styled-components/native';
import { RFValue } from "react-native-responsive-fontsize";

/* Fica logo abaixo do header, no fluxo normal. Antes era `position: absolute;
   top: 55px`, o que fixava a barra numa altura de header que não existe mais em
   todas as larguras — no celular os chips encostavam/sobrepunham o header. */
export const Container = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  z-index: 10;
  padding-top: ${({ compact }) => (compact ? 2 : 6)}px;
`;

export const ClearButton = styled.TouchableOpacity`
  margin-right: ${({ compact }) => (compact ? 8 : 12)}px;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => props.borderRadiusButton}px;
  borderColor: ${(props) => props.borderColor};
  border-width: 1px;
  padding: ${({ compact }) => (compact ? 5 : 3)}px;
`;

export const Chip = styled.TouchableOpacity`
  padding-vertical: ${({ compact }) => (compact ? 5 : 8)}px;
  padding-horizontal: ${({ compact }) => (compact ? 12 : 14)}px;
  border-radius: ${p => p.borderRadiusButton}px;
  border-color: ${p => p.borderColor};
  background-color: ${p => p.backgroundColor || 'transparent'};
  border-width: 1px;
  margin-right: ${({ compact }) => (compact ? 8 : 12)}px;
  /* iOS shadow */
  shadow-offset: 0px 1px;
  shadow-opacity: 0.2;
  shadow-radius: 2px;
`;

export const Text = styled.Text`
  color: ${({ theme, color }) => color || theme?.colors?.text?.app};
  font-size: ${({ theme, fontSize }) => fontSize || RFValue(theme?.fontSizes?.md)}px;
  font-family: ${({ theme, fontFamily }) => fontFamily || theme?.fonts?.text};
  text-align: ${({ textAlign }) => textAlign || "center"};
  margin-top: ${({ mt }) => mt || 0}px;
  margin-bottom: ${({ mb }) => mb || 0}px;
  text-decoration-line: ${(props) => props?.underline ? "underline" : "none"};
  font-weight: ${({ fontWeight }) => fontWeight || "normal"};
`;
